import React, {Fragment, useEffect} from 'react';

import '../../App.css';
import {Outlet, useMatches, useNavigate, useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {Button, Col, Flex, Modal, Row, Segmented, Space, Tooltip} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faAngleLeft,
    faChildren,
    faEarthAmericas,
    faGrip,
    faList,
    faPlus
} from "@fortawesome/free-solid-svg-icons";
import {deleteStory, fetchStory, saveStory} from "../../feature/project/storySlice";
import {Act, Story} from "../../feature/project/story";
import {AddStoryModal} from "./AddStoryModal";
import {Status} from "../../feature/project/status";
import {AddActModal} from "../act/AddActModal";
import {useCookies} from "react-cookie";
import {fetchActs, saveAct} from "../../feature/project/actSlice";
import Acts from "../act/Acts";
import {ViewMode} from "../common/ViewMode";
import {EntityDetails} from "../common/EntityDetails";
import Title from "antd/es/typography/Title";
import {editorRoles, WithUserPermission} from "../common/WithUserPermission";

const {confirm} = Modal;

const StoryDetails = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const {storyId, projectId} = useParams()
    const story = useAppSelector(state => state.stories.story)
    const project = useAppSelector(state => state.projects.project)
    const status = useAppSelector(state => state.stories.status)
    const chaptersStatus = useAppSelector(state => state.chapters.status)
    const matches = useMatches()
    const [modal, setModal] = React.useState(false)
    const [chapterModal, setActModal] = React.useState(false)

    useEffect(() => {
        if (projectId && storyId && (status === Status.Idle && story?.id !== parseInt(storyId))) {
            dispatch(fetchStory({projectId: parseInt(projectId), storyId: parseInt(storyId)}))
        }
    }, [status, projectId, storyId])

    useEffect(() => {
        if (projectId && storyId && (chaptersStatus === Status.Idle || story?.id !== parseInt(storyId))) {
            dispatch(fetchActs({projectId: parseInt(projectId), storyId: parseInt(storyId)}))
        }
    }, [chaptersStatus, projectId, storyId, dispatch])

    const showDeleteConfirm = () => {
        confirm({
            title: 'Delete Story',
            content: 'Are you sure you want to delete this story?',
            icon: <></>,
            okText: 'Yes, delete',
            okButtonProps: {danger: true, type: 'primary'},
            cancelText: 'No',
            onOk() {
                if (!storyId || !projectId) return
                dispatch(deleteStory({projectId: parseInt(projectId), storyId: parseInt(storyId)}))
                navigate(`/projects/${projectId}`)
            },
        });
    };

    return (
        <Fragment>
            {
                matches[matches.length - 1].pathname.includes('/setting') ||
                matches[matches.length - 1].pathname.includes('/lore') ||
                matches[matches.length - 1].pathname.includes('/acts') ||
                matches[matches.length - 1].pathname.includes('/notes') ||
                matches[matches.length - 1].pathname.includes('/script') ||
                matches[matches.length - 1].pathname.includes('/outlines') ||
                matches[matches.length - 1].pathname.includes('/graph') ||
                matches[matches.length - 1].pathname.includes('/files') ||
                matches[matches.length - 1].pathname.includes('/story-crafter')
                    ?
                    <Outlet/> :
                    <Row style={{height: "100%"}}>
                        <Col span={story ? 16 : 24} style={{height: "100%"}}>
                            <Flex justify={'space-between'}>

                                <Space>
                                    <Button type={'text'} onClick={() => navigate(`/projects/${projectId}`)}
                                            icon={<FontAwesomeIcon icon={faAngleLeft}/>}/>
                                    <Title level={4} style={{margin: 0}}>Acts</Title>

                                </Space>

                                <Space>
                                    <WithUserPermission roles={editorRoles}>
                                        <Tooltip title="Add Act">
                                            <Button icon={<FontAwesomeIcon icon={faPlus}/>}
                                                    onClick={() => setActModal(true)}>Add
                                                Act</Button>
                                        </Tooltip>
                                    </WithUserPermission>
                                </Space>
                            </Flex>
                            <Acts/>
                        </Col>
                        {story ? <Col span={8} style={{height: "100%"}}>
                            <EntityDetails
                                entity={story}
                                onDeleteClick={() => {
                                    showDeleteConfirm()
                                }}
                                onEditClick={() => setModal(true)}
                                extra={
                                    <Space>
                                        <Tooltip title="Story Setting">
                                            <Button
                                                onClick={() => navigate(`/projects/${projectId}/stories/${storyId}/setting`)}
                                                icon={<FontAwesomeIcon icon={faEarthAmericas}/>}>Setting</Button>
                                        </Tooltip>
                                        <Tooltip title="Lore">
                                            <Button
                                                onClick={() => navigate(`/projects/${projectId}/stories/${storyId}/lore`)}
                                                icon={<FontAwesomeIcon icon={faChildren}/>}>Lore</Button>
                                        </Tooltip>
                                    </Space>
                                }
                            />
                        </Col> : ''}
                    </Row>
            }
            {story ?
                <AddStoryModal
                    story={story}
                    visible={modal}
                    onCancel={() => setModal(false)}
                    onSave={(story: Story) => {
                        if (project) {
                            dispatch(saveStory({projectId: project.id, story: story}))
                        }
                        setModal(false)
                    }}
                /> : ''}
            <AddActModal
                act={{title: '', description: '', cover: '', tags: []}}
                visible={chapterModal}
                onCancel={() => setActModal(false)}
                onSave={(chapter: Act) => {
                    if (project && storyId) {
                        chapter.storyId = parseInt(storyId)
                        dispatch(saveAct({projectId: project.id, act: chapter}))
                    }
                    setActModal(false)
                }}
            />
        </Fragment>
    );
};

export default StoryDetails;